/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { groupBy } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

const __vue_script__ = {
    name: 'SpeaksAt',

    components: {
        Badge,
        ExpandableContent
    },

    extends: BaseControl,

    props: {
        edit: {
            type: Boolean,
            default: false
        },

        model: {
            type: Object,
            required: true
        },

        value: {
            type: [Array, String],
            default: () => []
        }
    },

    data() {
        return {
            sessions: [],
            days: [],
            ready: false
        };
    },

    computed: {
        enabled() {
            return this.edit && this.ready && this.sessions.length > 0;
        }
    },

    created() {
        this.getSessions();
    },

    methods: {
        async getSessions() {
            try {
                const rawSessions = await this.$services.handlers.callHandler(this.event._id, 'presenter/sessions', {
                    presenter: this.model.fp_ext_id
                });

                this.sessions = rawSessions
                    .map(session => session.doc)
                    .sort((a, b) => a.start - b.start);

                for (const session of this.sessions) {
                    session.label = await this.getSessionLabel(session);
                    session.day = this.$utils.time.tsToFormat(session.start, 'LL', this.event.timezone);
                    session.time = this.$utils.time.tsToFormat(session.start, 'LT', this.event.timezone);
                }

                this.days = groupBy(this.sessions, 'day');
                this.markConflictingSessions();

            } catch (error) {
                console.error('[SpeaksAt] Error fetching sessions', error.message);
            } finally {
                this.ready = true;
            }
        },

        markConflictingSessions() {
            for (const day of Object.values(this.days)) {
                for (const session of day) {
                    session.conflicts = this.sessions.some(s => {
                        if (s._id !== session._id) {
                            const startsConflicts = this.$utils.time.dateIsBetween(session.start, s.start, s.end, {
                                includeStart: true,
                                includeEnd: true
                            });

                            const endConflicts = this.$utils.time.dateIsBetween(session.end, s.start, s.end, {
                                includeStart: true,
                                includeEnd: true
                            });

                            return startsConflicts || endConflicts;
                        }
                        return false;
                    });
                }
            }
        },

        getSessionLabel(session) {
            return this.$services.metadata.getReprLabelForItem(this.event._id, session, this.$i18n);
        },

        getSessionHref(session) {
            const agenda = this.$services.blueprint.getModuleByName('sessions');

            return this.$utils.modules.getRouteHref(agenda, 'view', {
                eventId: this.event._id,
                _id: session._id
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c(
        "expandable-content",
        {
          staticClass: "speaks-at",
          attrs: { "clickable-header": true },
          scopedSlots: _vm._u(
            [
              {
                key: "header",
                fn: function (ref) {
                  return [
                    _c(
                      "h5",
                      [
                        _vm._v(_vm._s(_vm.label)),
                        _c("badge", { staticClass: "info" }, [
                          _vm._v(_vm._s(_vm.sessions.length)),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            1700754520
          ),
        },
        _vm._l(_vm.days, function (sessions, day) {
          return _c("div", { key: day, staticClass: "days" }, [
            _c("h4", [_vm._v(_vm._s(day))]),
            _c(
              "ul",
              _vm._l(sessions, function (session) {
                return _c("li", { key: session.fp_ext_id }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getSessionHref(session) } },
                    [
                      session.conflicts
                        ? _c("badge", { staticClass: "warn badge-icon" }, [
                            _c("i", { staticClass: "ic-warning-fill" }),
                          ])
                        : _vm._e(),
                      _c("badge", [_vm._v(_vm._s(session.time))]),
                      _c("span", [_vm._v(_vm._s(session.label))]),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/presenters/SpeaksAt.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__